import {ReactElement, ReactNode} from 'react';
import {Provider} from 'react-redux';
import {BrowserRouter, HashRouter} from 'react-router-dom';
import {ReactQueryDevtools} from '@tanstack/react-query-devtools';
import {I18nextProvider} from 'react-i18next';
import {i18n} from '../configs/i18n/i18n';
import QUERY_CLIENT_CONFIG from '../configs/query.config';
import store from 'store';
import {environments} from 'configs';
import {QueryClientProvider} from '@tanstack/react-query';
import {ChekinSDKProvider} from './ChekinSDK';
import {SummaryProvider} from './summary';
import {GuestProvider} from './guest';
import {ReservationProvider} from './reservation';
import {WebsocketProvider} from './websocket';
import {ThemeProvider} from './theme';
import {CustomThemeProvider} from './customTheme';
import {IpDetailsProvider} from './ipDetails';
import {KioskoProvider} from './kiosko';
import {SDKDialogProvider} from './SDKDialogProvider';

type AppProvidersProps = {
  children: ReactNode | ReactElement;
};

const BaseRouter = environments.VITE_APP_IS_SDK ? HashRouter : BrowserRouter;

function AppProviders({children = null}: AppProvidersProps) {
  return (
    <Provider store={store}>
      <QueryClientProvider client={QUERY_CLIENT_CONFIG}>
        <BaseRouter>
          <ChekinSDKProvider>
            <I18nextProvider i18n={i18n}>
              <WebsocketProvider>
                <KioskoProvider>
                  <IpDetailsProvider>
                    <CustomThemeProvider>
                      <ReservationProvider>
                        <SummaryProvider>
                          <ThemeProvider>
                            <GuestProvider>
                              <SDKDialogProvider>{children}</SDKDialogProvider>
                            </GuestProvider>
                          </ThemeProvider>
                        </SummaryProvider>
                      </ReservationProvider>
                    </CustomThemeProvider>
                  </IpDetailsProvider>
                </KioskoProvider>
              </WebsocketProvider>
            </I18nextProvider>
          </ChekinSDKProvider>
        </BaseRouter>
        <ReactQueryDevtools />
      </QueryClientProvider>
    </Provider>
  );
}
export default AppProviders;
